import { useState } from 'react';
import { useGetCanaryRolloutStatus } from 'src/hooks';
import {
  acknowledgeCanaryModalForSession,
  dismissCanaryModal,
  hasAcknowledgedCanaryModalThisSession,
  hasDismissedCanaryModal,
} from 'src/utils';

import { CanaryAcknowledgeModal } from './CanaryAcknowledgeModal';

export const CanaryAcknowledgeModalContainer = () => {
  const { data } = useGetCanaryRolloutStatus();
  // sessionStorage isn't reactive on its own; this just forces a re-render after writing to
  // it so the derived modalOpen below re-evaluates immediately.
  const [, forceRender] = useState(0);

  const canaryWindowOpen = data?.canaryWindowOpen ?? false;
  const controlLastModified = data?.controlLastModified;

  const modalOpen =
    canaryWindowOpen &&
    !!controlLastModified &&
    !hasDismissedCanaryModal(controlLastModified) &&
    !hasAcknowledgedCanaryModalThisSession(controlLastModified);

  const onAcknowledge = (dontShowAgain: boolean) => {
    if (controlLastModified) {
      acknowledgeCanaryModalForSession(controlLastModified);
      if (dontShowAgain) {
        dismissCanaryModal(controlLastModified);
      }
    }
    forceRender((count) => count + 1);
  };

  return (
    <CanaryAcknowledgeModal open={modalOpen} onAcknowledge={onAcknowledge} />
  );
};
